import { render, staticRenderFns } from "./Split.vue?vue&type=template&id=5388d228&"
import script from "./Split.vue?vue&type=script&lang=js&"
export * from "./Split.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports